import React from "react";
import courseDetails from "../../images/courses-details.jpg";
import circle from "../../images/circle-shape.png";
import author from "../../images/author-03.jpg";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape14 from "../../images/shape-14.png";
import logo from "../../images/logo.png";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
// import { Player, ControlBar, ForwardControl, ReplayControl,BigPlayButton  ,PlaybackRateMenuButton } from 'video-react';
// import 'video-react/dist/video-react.css';
import { useRef } from "react";
import Accordion from "react-bootstrap/Accordion";
import "./Adver.css";
// import { Link } from "react-router-dom";
import video from "../../images/videoo.mp4";
import {
  Player,
  ControlBar,
  ForwardControl,
  ReplayControl,
  BigPlayButton,
  PlaybackRateMenuButton,
} from "video-react";
import "video-react/dist/video-react.css";

// import courseDetails from '../../images/courses-details.jpg';
const Adver = () => {
  const [isLoading, setIsLoading] = useState(false);

    const [courseDet, setcourseDet] = useState([]);
    let {id, name} = useParams();
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [ids, setids] = useState([]);
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    function getShow(){
      setShow(true)
    }
    function getVerify(s){
        var inputVal = document.getElementById("myInput").value;
        axios
        .patch(
          `https://maps-medics-be.onrender.com/use_permission/${inputVal}/${sessionStorage.getItem('user_id')}`,
        )
        
        .then((res) => {
          if (res.data.success) {
            console.log(res.data);
            navigate('/courseDetails/'+ sessionStorage.getItem('cource_id') );
          } else {
            throw new Error("Verification failed");
          }
        })
        .catch((err) => {
          console.error(err);
          {navigate('/login')}
        });
      }
    function Nav(s) {
        // e.preventDefault()
        console.log("omar sameh")
        // handleShow()
        setids(s.id);
      
        sessionStorage.setItem("cource_id", s.id);
  
        if(sessionStorage.getItem('loggedIn')){
            if (sessionStorage.getItem('cource_id' , s.id) && s.enrolled === true) {
              navigate('/courseDetails/'+ sessionStorage.getItem('cource_id') )
              // Check if the user is logged in and has a course ID set in local storage
              console.log(s.name)
        //
              // navigate('/courseDetails/'+ sessionStorage.getItem('cource_id')+ '/' + s.name ) ;
              // console.log('amjod')
            } else {
            
           
           getShow();
             
              // navigate('/login'); // If the user is not logged in or does not have a course ID set, redirect to the login page
              // console.log('dav')
        
            }
          }
          else{
            navigate('/login');
          }
      }
    // let { id } = useParams()
    console.log(id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function getcourseDet() {
    let { data } = await axios.post(
      "https://maps-medics-be.onrender.com/show_course/" + id, sessionStorage.getItem('user_id')?{student_id:  sessionStorage.getItem('user_id')}: {}
    );
    setcourseDet(data.result);
    console.log(data.result);
  }


useEffect(() => {
      
    getcourseDet();
  }, []);

  const playerRef = useRef(null);

  const handleSeekBackward = (seconds) => {
    const currentTime = playerRef.current.getState().player.currentTime;
    playerRef.current.seek(currentTime - seconds);
  };

  const handleSeekForward = (seconds) => {
    const currentTime = playerRef.current.getState().player.currentTime;
    playerRef.current.seek(currentTime + seconds);
  };
  const handleSpeedChange = (speed) => {
    playerRef.current.setPlaybackRate(speed);
  };


  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    const formattedDuration = [];
    if (hours > 0) {
      formattedDuration.push(`${hours}h`);
    }
    if (minutes > 0) {
      formattedDuration.push(`${minutes}m`);
    }
    if (seconds > 0) {
      formattedDuration.push(`${seconds}s`);
    }

    return formattedDuration.join(" ");
  };
  const handleClick = (courseDet) => {
    // Disable the button immediately
    setIsLoading(true);

    // Wait for 2 seconds
    setTimeout(() => {
      // Enable the button after 2 seconds
      setIsLoading(false);

      // Perform the original onclick function here
      Nav(courseDet);
    }, 2000);
  };

  return (
    <>

<Modal show={show} onHide={handleClose} className='alretCourse' style={{display:'flex', justifyContent:'center' , alignItems:'center'}}>
<Modal.Header closeButton>
  <Modal.Title>Please Enter The Verification code!</Modal.Title>
</Modal.Header>
<Modal.Body>
  <Form>
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
      <Form.Label>Enter Verification Code</Form.Label>
      <Form.Control
        type="text"
        autoFocus
        id="myInput"
      />
    </Form.Group>
 
  </Form>
</Modal.Body>
<Modal.Footer>

  <Button variant="primary" onClick={getVerify} style={{backgroundColor:'#ffc600' , border:'1px solid #ffc600'}}>
    Submit
  </Button>
</Modal.Footer>
</Modal> 
      {/* <Navbar/> */}
      <div className="section "></div>

      <div class="section page-banner">
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="page-banner-content">
              <h2 class="title" style={{ color: "#fff" }}>
                <span>{courseDet.name}</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-padding mt-n10">
        <div class="container">
          <div class="row gx-10">
            <div class="col-lg-8">
              <div class="courses-details">
                {/* <div class="courses-details-images">
                                <img src={courseDetails} alt="Courses Details"/>
                    
                            </div> */}

                <h2
                  class="title"
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "700",
                    fontSize: "26px",
                  }}
                >
                 {courseDet.name}
                </h2>

                <div class="courses-details-admin">
                  <div class="admin-author">
                    <div class="author-thumb">
                      <img src={logo} alt="Author" />
                    </div>
                    <div class="author-content">
                      <span>By</span>{" "}
                      <a
                        class="name"
                        href="#"
                        style={{ color: "#000", textDecoration: "none" }}
                      >
                        {" "}
                        Maps Team{" "}
                      </a>
                      <span>Categories:</span>{" "}
                      <span
                        class="Enroll"
                        style={{ color: "#000", fontWeight: "bold" }}
                      >
                        {" "}
                        {courseDet.name}
                      </span>
                    </div>
                  </div>
                  <div class="admin-rating">
                    <span class="rating-count">4.9</span>
                    <span>
                      <i
                        class="fa-regular fa-star"
                        style={{ color: "#ffc600" }}
                      ></i>
                      <i
                        class="fa-regular fa-star"
                        style={{ color: "#ffc600" }}
                      ></i>
                      <i
                        class="fa-regular fa-star"
                        style={{ color: "#ffc600" }}
                      ></i>
                      <i
                        class="fa-regular fa-star"
                        style={{ color: "#ffc600" }}
                      ></i>
                    </span>
                    <span class="rating-text">(5,764 Rating)</span>
                  </div>
                </div>

                <div class="courses-details-tab">
                  <Player
                    ref={playerRef}
                    autoPlay={false}
                    src={video}
                    width="100%"
                    height="100%"
                    controlBarClassName="my-custom-class"
                    playbackRate={0.5}
                  >
                    <BigPlayButton position="center" />

                    <ControlBar autoHide={false} className="my-class">
                      <ReplayControl seconds={10} order={2} />
                      <ForwardControl seconds={10} order={3} />
                      <PlaybackRateMenuButton
                        rates={[1.75, 1.5, 1.25, 1, 0.75, 0.5]}
                      />
                    </ControlBar>
                  </Player>
                  {/* 
                             
                                <div class="details-tab-content">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="description">

                                          
                                            <div class="tab-description">
                                                <div class="description-wrapper">
                                                </div>
                                             
                                            </div>
                                      

                                        </div>
                                        <div class="tab-pane fade" id="instructors">

                                            
                                    

                                        </div>
                                     
                                    </div>
                                </div> */}
                </div>
                <div class="container">
                  <h1
                    class="title"
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "700",
                      fontSize: "26px",
                    }}
                  >
                    About Course
                  </h1>
                  <div class="row">
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item
                        eventKey="0"
                        style={{ marginBottom: "7px" }}
                      >
                        <Accordion.Header>
                          {" "}
                          What is special about Maps Medics?
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ color: "#000", paddingBottom: "5px" }}
                        >
                          The Maps Medics USMLE Step 1 Preparatory Course is
                          designed to help medical students succeed in the
                          United States Medical Licensing Examination (USMLE)
                          Step 1. This comprehensive course is aligned with the
                          USMLE course outline and covers all the necessary
                          topics and concepts to help students pass the exam.
                          Our case-based approach simulates the USMLE
                          experience, giving students the skills and knowledge
                          they need to succeed on their exam day. With over 180
                          Board-Style Question Breakdown Video Lectures covering
                          +3,600 questions aligned with the USMLE course
                          outline, and +1.400 must-know high-yield concepts, our
                          playlistcovers the entire medical curriculum in an
                          orderly manner, with in-depth explanations of correct
                          and incorrect choices. We use simple language, bullet
                          points, diagrams, images, fun mnemonics, and color
                          coding to break down complex concepts of general
                          principles and organ systems and make them easy to
                          understand. Our video lectures are designed to help
                          students understand how medical concepts are applied
                          in real-world situations, making the information more
                          relatable and easier to remember. Subscribing to this
                          course also includes a 1 year of unlimited access to
                          our extensive question bank, and well-crafted notes.
                          We carefully designed this playlist so you may study
                          in one place, rather than all over the place. With
                          Maps Medics, you will have everything you need to pass
                          the USMLE Step 1 exam. Enroll in our USMLE Step 1
                          Preparatory Course today and take the first step
                          towards achieving your medical dreams.
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                  <div className="row">
                    <h1
                      class="title"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: "700",
                        fontSize: "26px",
                        marginBottom: "2%",
                      }}
                    >
                      What Will You Learn?
                    </h1>
                    <div className="col-md-6">
                      <ul style={{ listStyleType: "disc" }}>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Biochemistry
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Microbiology and Infectious Diseases
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Basics of Pharmacology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Cardiology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Gastroenterology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Musculoskeletal and Special Senses
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Nephrology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Pulmonology
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul style={{ listStyleType: "disc" }}>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Immunology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Basics of Pathology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Public Health Sciences
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Endocrinology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Hematology and Oncology
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Psychiatry
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontFamily: "Poppins",
                            fontWeight: "400",
                            fontSize: "17px",
                          }}
                        >
                          Reproductive
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="row">
                    <h1
                      class="title"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: "700",
                        fontSize: "26px",
                        marginBottom: "2%",
                      }}
                    >
                      Course Content
                    </h1>
                    <Accordion>
                      <Accordion.Item
                        eventKey="0"
                        style={{ marginBottom: "15px" }}
                      >
                        <Accordion.Header className="Accordion.Header">
                          Pyschiatry Maps
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ color: "#000", paddingBottom: "5px" }}
                        >
                          {" "}
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item
                        eventKey="1"
                        style={{ marginBottom: "7px" }}
                      >
                        <Accordion.Header className="Accordion.Header">
                          {" "}
                          MSK Maps
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ color: "#000", paddingBottom: "5px" }}
                        >
                          {" "}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="sidebar">
                <div class="sidebar-widget widget-information">
                  <div class="info-price">
               
                      <button class="btn startLearningAdver"   style={{ color: "#fff", textDecoration: "none" }}   onClick={() => handleClick(courseDet)}
      disabled={isLoading}>
                        {" "}
                        Start Learning <i class="fa-solid fa-book-open"></i>
                      </button>
                    
                  </div>
                  <div
                    class="info-list"
                    style={{ backgroundColor: "#fff", paddingTop: "10px" }}
                  >
                    <ul style={{ marginBottom: "0" }}>
                      <li>
                        <i
                          class="fa-solid fa-signal"
                          style={{ color: "#000" }}
                        ></i>
                      {courseDet.instructor}
                      </li>
                      <li>
                        <i
                          class="fa-solid fa-graduation-cap"
                          style={{ color: "#000" ,marginRight:'5px'}}
                        ></i>{courseDet.total_enrolled} Total Enrolled
                      </li>
                      <li>
                        <i
                          class="fa-regular fa-clock"
                          style={{ color: "#000" }}
                        ></i>
                        Duration {formatDuration(courseDet.hours)} 
                      </li>
                      <li>
                        <i
                          class="fa-solid fa-arrow-rotate-left"
                          style={{ color: "#000" }}
                        ></i>
                        Last Update January 25, 2023
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="sidebar-widget widget-information">
                  <div class="info-price">
                    <span
                      class="price"
                      style={{
                        color: "#000",
                        fontSize: "16px",
                        textAlign: "left",
                        marginLeft: "7%",
                        fontWeight: "500",
                      }}
                    >
                      A Course By
                    </span>
                    <div style={{ display: "flex", justifyContent: "start" }}>
                      {" "}
                      <img src={logo} alt="" />
                    </div>
                  </div>
                  <div class="info-list">
                    <h3 className="klmamohma" style={{ paddingLeft: "7%" }}>
                      Material Includes
                    </h3>
                    <ul style={{ listStyleType: "disc" }}>
                      <li>Mastery Maps USMLE Step 1 Notes</li>
                      <li>Board-style Question Bank</li>
                      <li>Visual Mnemonics</li>
                    </ul>
                    <h3 className="klmamohmaawy" style={{ paddingLeft: "7%" }}>
                      Requirements
                    </h3>
                    <ul style={{ listStyleType: "disc" }}>
                      <li>Medical Students</li>
                      <li>Latest version of Google Chrome</li>
                    </ul>
                    <h3 className="klmamohmaawy" style={{ paddingLeft: "7%" }}>
                      Audience
                    </h3>
                    <ul style={{ listStyleType: "disc" }}>
                      <li>Arabic-Speaking medical students.</li>
                      <li>
                        Medical students preparing for the USMLE Step 1 exam
                      </li>
                      <li>
                        Medical graduates looking to take the USMLE Step 1 exam
                      </li>
                      <li>
                        Medical students looking to improve their understanding
                        of basic medical concepts
                      </li>
                      <li>
                        Medical students looking for a comprehensive review of
                        the medical curriculum
                      </li>
                      <li>
                        Medical students seeking personalized support and
                        guidance in their USMLE Step 1 exam preparation
                      </li>
                      <li>
                        Medical students looking for a case-based approach to
                        learning that simulates the USMLE experience
                      </li>
                      <li>
                        Medical students who are looking to save time and money
                        on their medical education journey
                      </li>
                      <li>
                        Medical students who want to increase their chances of
                        getting into a residency program.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Adver;
